import ReportView from '@/views/app/report/report-view.vue'
import ReportList from '@/modules/report/report-list'

export default [
  {
    path: 'report',
    name: 'report',
    component: ReportView,
    children: [
      {
        path: '',
        name: 'report-list',
        component: ReportList
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/app/report/index.js